import { Col, List, Row, Typography, Image, Progress, Button } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import transferIcon from "../../assets/transfer-icon.png";
import starsIcon from "../../assets/stars-icon.png";
import { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useMobxStores } from "../../stores/stores";
import { observer } from "mobx-react";
import "./ActivityContainer.css";

const ActivityContainer = () => {
  const { marketplaceStore } = useMobxStores();
  const params = useParams();

  const [showTopIndicator, setShowTopIndicator] = useState(false);
  const [showBottomIndicator, setShowBottomIndicator] = useState(false);
  const listRef = useRef(null);

  const eventsStatus = marketplaceStore.marketplaceItem?.events_status;
  const events = useMemo(
    () => marketplaceStore.marketplaceItem?.events ?? [],
    [marketplaceStore.marketplaceItem]
  );

  const handleTryAgain = () => {
    marketplaceStore.RetryMarketplaceItemHistory(params.pk);
  };

  useEffect(() => {
    const activityList = listRef.current;
    setShowBottomIndicator(
      activityList?.clientHeight < activityList?.scrollHeight
    );

    const handleScroll = () => {
      if (activityList) {
        setShowTopIndicator(activityList.scrollTop > 0);
        setShowBottomIndicator(
          Math.abs(
            activityList.scrollTop +
              activityList.clientHeight -
              activityList.scrollHeight
          ) > 1
        );
      }
    };
    activityList?.addEventListener("scroll", handleScroll);

    return () => activityList?.removeEventListener("scroll", handleScroll);
  }, [events]);

  return (
    <>
      {eventsStatus && (
        <Col
          span={marketplaceStore.marketplaceItem.badges?.length > 0 ? 14 : 22}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            marginTop: "32px",
          }}
        >
          <div className="activity-title-container">
            <div className="activity-title">Activity</div>
          </div>
          {eventsStatus === "loading" && (
            <div className="activity-container">
              <Progress
                percent={marketplaceStore.historyProgressDisplay}
                status="active"
              />
              <Typography.Paragraph style={{ color: "#000080", marginTop: 8 }}>
                Loading transaction history from the blockchain… this can
                take a few minutes the first time.
              </Typography.Paragraph>
            </div>
          )}
          {eventsStatus === "error" && (
            <div className="activity-container">
              <Typography.Paragraph style={{ color: "#000080" }}>
                Transaction history is currently unavailable.
              </Typography.Paragraph>
              <Button onClick={handleTryAgain}>Try again</Button>
            </div>
          )}
          {eventsStatus === "ok" && events.length === 0 && (
            <div className="activity-container">
              <Typography.Paragraph style={{ color: "#000080", margin: 0 }}>
                No transactions yet.
              </Typography.Paragraph>
            </div>
          )}
          {eventsStatus === "ok" && events.length > 0 && (
          <div style={{ position: "relative" }}>
            <div className="activity-container" ref={listRef}>
              <List
                dataSource={events}
                renderItem={(item, index) => (
                  <Row
                    key={`event-${index}`}
                    className="activity-entry"
                    gutter={16}
                  >
                    <Col>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          height: "52px",
                          width: "52px",
                        }}
                        className="activity_icon"
                      >
                        {" "}
                        <Image
                          src={
                            item.from_address ===
                            "0x0000000000000000000000000000000000000000"
                              ? starsIcon
                              : transferIcon
                          }
                          preview={false}
                        />
                      </div>
                    </Col>
                    <Col span={21} xs={18} sm={18}>
                      <Typography.Paragraph
                        style={{ color: "#000080", fontWeight: 300 }}
                      >
                        {item.from_address ===
                        "0x0000000000000000000000000000000000000000" ? (
                          <>
                            {item.amount}
                            {` ${
                              item.amount === 1 ? "edition" : "editions"
                            }`}{" "}
                            minted by{" "}
                            <span className="bold-address">
                              {item.to_address}
                            </span>
                          </>
                        ) : (
                          <>
                            {item.amount}
                            {` ${
                              item.amount === 1 ? "edition" : "editions"
                            }`}{" "}
                            transferred from{" "}
                            <span className="bold-address">
                              {item.from_address}
                            </span>{" "}
                            to{" "}
                            <span className="bold-address">
                              {item.to_address}
                            </span>
                          </>
                        )}
                        <br />
                        <span
                          className="activity-date"
                          style={{
                            color: "#B46FBA",
                          }}
                        >
                          {item.timestamp}
                        </span>
                      </Typography.Paragraph>
                    </Col>
                  </Row>
                )}
              />
            </div>
            {showTopIndicator && (
              <div
                style={{
                  position: "absolute",
                  top: "24px",
                  right: "32px",
                }}
              >
                <UpOutlined style={{ color: "#000080", fontSize: "32px" }} />
              </div>
            )}
            {showBottomIndicator && (
              <div
                style={{
                  position: "absolute",
                  bottom: "24px",
                  right: "32px",
                }}
              >
                <DownOutlined style={{ color: "#000080", fontSize: "32px" }} />
              </div>
            )}
          </div>
          )}
        </Col>
      )}
    </>
  );
};

export default observer(ActivityContainer);
